/* Nusoran theme — minimal vanilla JS (no framework) */
(function () {
  "use strict";

  /* Mobile menu toggle */
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest(".menu-toggle");
    if (toggle) {
      var nav = document.querySelector(".nav-links");
      if (nav) nav.classList.toggle("is-open");
    }
  });

  /* Quantity steppers: <div class="qty"><button data-qty="-">…<input>…<button data-qty="+"> */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-qty]");
    if (!btn) return;
    var wrap = btn.closest(".qty");
    if (!wrap) return;
    var input = wrap.querySelector("input");
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val = btn.getAttribute("data-qty") === "+" ? val + 1 : Math.max(1, val - 1);
    input.value = val;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* PDP gallery: click a thumb to swap the main image */
  document.addEventListener("click", function (e) {
    var thumb = e.target.closest(".gallery-thumbs .th");
    if (!thumb) return;
    var gallery = thumb.closest(".gallery");
    if (!gallery) return;
    var main = gallery.querySelector(".gallery-main img");
    var thumbImg = thumb.querySelector("img");
    if (main && thumbImg) {
      main.src = thumb.getAttribute("data-full") || thumbImg.src;
      gallery.querySelectorAll(".gallery-thumbs .th").forEach(function (t) {
        t.classList.remove("active");
      });
      thumb.classList.add("active");
    }
  });

  /* PDP gallery: hover-zoom the main image (zoom follows the cursor) */
  document.querySelectorAll(".gallery-main").forEach(function (box) {
    var img = box.querySelector("img");
    if (!img) return;
    box.addEventListener("mousemove", function (e) {
      var r = box.getBoundingClientRect();
      img.style.transformOrigin =
        ((e.clientX - r.left) / r.width) * 100 + "% " +
        ((e.clientY - r.top) / r.height) * 100 + "%";
      img.style.transform = "scale(2)";
    });
    box.addEventListener("mouseleave", function () {
      img.style.transform = "scale(1)";
    });
  });

  /* Product carousel: prev/next arrows, dots, optional autoplay (vanilla, no library) */
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  document.querySelectorAll("[data-carousel]").forEach(function (root) {
    var track = root.querySelector("[data-carousel-track]");
    if (!track) return;
    var prev = root.querySelector("[data-carousel-prev]");
    var next = root.querySelector("[data-carousel-next]");
    var dotsBox = root.querySelector("[data-carousel-dots]");
    var behavior = reduceMotion ? "auto" : "smooth";

    function step() {
      var card = track.children[0];
      if (!card) return track.clientWidth;
      var gap = parseInt(getComputedStyle(track).columnGap, 10) || 24;
      var cardW = card.getBoundingClientRect().width + gap;
      var per = Math.max(1, Math.round(track.clientWidth / cardW));
      return per * cardW;
    }
    function maxScroll() {
      return track.scrollWidth - track.clientWidth - 1;
    }
    function go(dir) {
      track.scrollBy({ left: dir * step(), behavior: behavior });
    }
    function update() {
      if (prev) prev.hidden = track.scrollLeft <= 0;
      if (next) next.hidden = track.scrollLeft >= maxScroll();
      if (dotsBox) {
        var i = Math.round(track.scrollLeft / step());
        dotsBox.querySelectorAll("button").forEach(function (d, di) {
          d.classList.toggle("active", di === i);
        });
      }
    }
    function buildDots() {
      if (!dotsBox) return;
      dotsBox.innerHTML = "";
      if (track.scrollWidth <= track.clientWidth + 2) return;
      var pages = Math.ceil((track.scrollWidth - track.clientWidth) / step()) + 1;
      for (var p = 0; p < pages; p++) {
        var b = document.createElement("button");
        b.type = "button";
        b.setAttribute("aria-label", "Go to slide " + (p + 1));
        (function (idx) {
          b.addEventListener("click", function () {
            track.scrollTo({ left: idx * step(), behavior: behavior });
          });
        })(p);
        dotsBox.appendChild(b);
      }
    }

    if (prev) prev.addEventListener("click", function () { go(-1); });
    if (next) next.addEventListener("click", function () { go(1); });
    track.addEventListener("scroll", function () { window.requestAnimationFrame(update); });
    window.addEventListener("resize", function () { buildDots(); update(); });
    buildDots();
    update();

    var speed = parseFloat(root.getAttribute("data-autoplay"));
    if (speed && !reduceMotion) {
      var timer = null;
      var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
      var play = function () {
        stop();
        timer = setInterval(function () {
          if (track.scrollLeft >= maxScroll()) track.scrollTo({ left: 0, behavior: behavior });
          else go(1);
        }, speed * 1000);
      };
      root.addEventListener("mouseenter", stop);
      root.addEventListener("mouseleave", play);
      root.addEventListener("focusin", stop);
      root.addEventListener("focusout", play);
      play();
    }
  });
})();
